import { CanopyProvider } from '@bloomfieldrobotics/canopy';
import { InfoOutlined } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { DebugInfoProps } from '../DebugInfo';
import DebugInfoDialogOnboarding from './DebugInfoDialogOnboarding';

export const DebugInfoLauncherOnboarding = ({
  customerID,
  ranchID,
  blockID,
  debugInfoUserID,
}: DebugInfoProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prevOpen) => !prevOpen);
        }}
        color='secondary'
      >
        <InfoOutlined />
      </IconButton>
      <CanopyProvider>
        <DebugInfoDialogOnboarding
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          customerID={customerID}
          ranchID={ranchID}
          blockID={blockID}
          debugInfoUserID={debugInfoUserID}
        />
      </CanopyProvider>
    </>
  );
};
